import { css } from '@emotion/react';
import { PREFIX } from '../constants';
import { COLORS } from './constants';

export const APP_COLORS = css(
  Object.entries(COLORS).reduce(
    (acc, [key, value]) => `${acc}${PREFIX.COLOR}${key}: ${value || 'none'};`,
    ''
  )
);
